import { FormBlock } from '@qbe/ads-blocks-forms';
import { FormGroupLabel, NumericFormat, Typography } from '@qbe/ads-core';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { useAppContent } from '~/hooks';

import { ContextualHelpWithButton } from '../../components-ds/ContextualHelp/ContextualHelpWithButton';
import { SpecificBusinessDetailsForm } from '../SpecificBusinessDetails/types';

export const NumberOfEmployees = () => {
  const { getTextContent, getJSXContent } = useAppContent({
    basePath: 'dsme.businessDetailsSpecificBusinessDetails',
  });

  const { control } = useFormContext<SpecificBusinessDetailsForm>();

  return (
    <>
      <FormGroupLabel
        title={getTextContent('fields.employeesInput.title')}
        alignCenter
        titleSuffix={
          <ContextualHelpWithButton tracking="help: How many employees do you have?">
            <Typography>{getJSXContent('contextualhelpers.employeesInput.description')}</Typography>
          </ContextualHelpWithButton>
        }
      />
      <FormBlock preset="input" maxWidth="100%" paddingBottom="none">
        <Controller
          name="numberOfEmployees"
          rules={{
            required: true,
            min: 1,
          }}
          control={control}
          data-track="Enter number of employees"
          data-track-value="mask"
          render={({ field: { ...field }, fieldState }) => {
            const isInvalid = Boolean(fieldState.error);
            return (
              <NumericFormat
                // customInput={TextField}
                thousandSeparator
                id="numberOfEmployees"
                name={field.name}
                label={getTextContent('fields.employeesInput.label')}
                required
                value={field.value !== undefined && field.value !== null ? String(field.value) : ''}
                allowNegative={false}
                onValueChange={(values) => field.onChange(values.floatValue ?? null)}
                data-track="Enter number of employee"
                data-track-value="mask"
                error={isInvalid}
                displayIcon
                helperText={
                  isInvalid
                    ? getTextContent('fields.employeesInput.invalidText')
                    : getTextContent('fields.employeesInput.helperText')
                }
              />
            );
          }}
        />
      </FormBlock>
    </>
  );
};
